import { z } from "zod";

export const GST_REGEX =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

export const gstFieldError = "Enter a valid 15-character GST number.";

export const gstSchema = z.string().regex(GST_REGEX, gstFieldError);

export function validateGst(value) {
  if (!value || value.length === 0) return { ok: true, empty: true };
  return { ok: GST_REGEX.test(value), empty: false };
}
